const FpsCounterElementId = 'fps-counter-element';
let fpsCounterData = {};
let fpsCounterElement = undefined;

// Note!
// The FpsCounter is created for QA and developers to debag the rendering process and improve performance.
// The user should not see it on production.
// Enable or disable the FpsCounter with (Shift + Ctrl + Alt) keys combination.

const createFpsCounterElement = () => {
    let fpsCounterElement = document.createElement('span');
    fpsCounterElement.id = FpsCounterElementId;
    fpsCounterElement.style.color = 'Red';
    fpsCounterElement.style.zIndex = 9999999;
    fpsCounterElement.style.position = 'fixed';
    fpsCounterElement.style.top = '20px';
    fpsCounterElement.style.right = '40%';
    fpsCounterElement.style.fontSize = '13pt';
    fpsCounterElement.style.fontWeight = 'bold';
    fpsCounterElement.innerText = `FPS: ${0}`;
    return fpsCounterElement;
};

const setFpsCounterColor = (element, fps) => {
    if (fps < 30) {
        element.style.color = 'Red';
        return;
    }
    element.style.color = 'Green';
};

const onFpsCounterEnableKeysPress = (event) => {
    if (event.shiftKey && (event.ctrlKey || event.metaKey) && event.altKey) {
        if (fpsCounterElement) {
            FpsCounter.disable();
        } else {
            FpsCounter.enable();
        }
    }
};

export const FpsCounter = {
    enable: () => {
        fpsCounterElement = document.getElementById(FpsCounterElementId);
        if (fpsCounterElement)
            return;

        fpsCounterData.lastFrameTime = undefined;
        fpsCounterData.elapsedTime = 0;
        fpsCounterData.elapsedFramesCount = 0;
      
        fpsCounterElement = createFpsCounterElement();
        document.body.appendChild(fpsCounterElement);
    },

    triggerFrame: () => {
        if (!fpsCounterData.lastFrameTime)
            fpsCounterData.lastFrameTime = performance.now();

        fpsCounterData.elapsedFramesCount++;
        let currentTime = performance.now();
        let duration = currentTime - fpsCounterData.lastFrameTime;

        fpsCounterData.elapsedTime += duration;
        fpsCounterData.lastFrameTime = currentTime;

        if (fpsCounterData.elapsedTime >= 1000) {
            setFpsCounterColor(fpsCounterElement, fpsCounterData.elapsedFramesCount);
            fpsCounterElement.innerText = `FPS: ${fpsCounterData.elapsedFramesCount}`;

            fpsCounterData.elapsedFramesCount = 0;
            fpsCounterData.elapsedTime = 0;
        }
    },

    disable: () => {
        fpsCounterData = {};

        if (fpsCounterElement)
            fpsCounterElement.remove();

        fpsCounterElement = undefined;
    },

    assignHotkeys: () => {
        document.removeEventListener('keydown', onFpsCounterEnableKeysPress);
        document.addEventListener('keydown', onFpsCounterEnableKeysPress);
    },

    removeHotkeys: () => {
        document.removeEventListener('keydown', onFpsCounterEnableKeysPress);
    }
};